import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllCheckProfessionalExistsUseCaseInterface } from 'domain/usecases';

export class RemoteGetCheckProfessionalExists
  implements GetAllCheckProfessionalExistsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllCheckProfessionalExistsUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllCheckProfessionalExistsUseCaseInterface.Params,
  ): Promise<GetAllCheckProfessionalExistsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url + '/' + params.cpf,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
